// extracted by mini-css-extract-plugin
export default {"modalLogInWrap":"style_modalLogInWrap__hmNqm","title":"style_title__W9IW9","description":"style_description__6B9LC","buttons":"style_buttons__zYLZz"};